import { DynamicSEO } from '../components/seo';
import Layout from '../components/Layout';

export default function PrivacyPage() {
  return (
    <Layout>
      <DynamicSEO
        meta={{
          title: "Privacy Policy - NameExplorer",
          description: "Learn about how NameExplorer protects your privacy and handles your data.",
          type: "website"
        }}
      />
      
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Privacy Policy</h1>
        
        <div className="prose prose-lg">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Data Collection</h2>
            <p className="text-gray-600">
              We collect minimal data necessary to provide our services. This includes:
            </p>
            <ul className="list-disc pl-6 text-gray-600">
              <li>Search queries for names</li>
              <li>Name preferences and likes</li>
              <li>Basic usage analytics</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Data Usage</h2>
            <p className="text-gray-600">
              Your data is used solely to improve our services and provide personalized
              recommendations. We never sell your personal information to third parties.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Cookies</h2>
            <p className="text-gray-600">
              We use essential cookies to maintain your preferences and improve your
              experience. You can control cookie settings through your browser.
            </p>
          </section>
        </div>
      </div>
    </Layout>
  );
}